"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _InstrumentSelectorComponent = _interopRequireDefault(require("./../InstrumentSelector/InstrumentSelectorComponent"));
var _instrumentActions = require("../../redux/actions/instrumentActions");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _selectors = require("../../redux/futures/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var selectedAccountId = (0, _selectors.selectedAccountIdSelector)(state);
  var isInstrumentsFetching = state.futures.instruments.fetching;
  var isTableDataFetching = state.futures.instruments.fetching || state.futures.level1.level1SummaryFetching;
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var level1 = (0, _instrumentPositionSelectors.level1Selector)(state);
  return {
    level1: level1,
    instruments: instruments,
    selectedAccountId: selectedAccountId,
    selectedInstrument: selectedInstrument,
    selectedRow: {
      key: 'InstrumentId',
      value: selectedInstrument.InstrumentId
    },
    isInstrumentsFetching: isInstrumentsFetching,
    isTableDataFetching: isTableDataFetching,
    isFuturesActive: true
  };
};
var mapDispatchToProps = {
  selectInstrument: _instrumentActions.selectInstrument
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InstrumentSelectorComponent["default"]);